'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Assert = require('../utility/Assert');

var _Assert2 = _interopRequireDefault(_Assert);

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

var _fs = require('fs');

var _fs2 = _interopRequireDefault(_fs);

var _log = require('../utility/log');

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 插件类加载起
 * 
 * @ignore
 * @export
 * @class PluginClassLoader
 */
var PluginClassLoader = function () {
    /**
     * 所在的插件
     * 
     * @ignore
     * @param {Plugin} plugin 插件
     * @memberof PluginClassLoader
     */
    function PluginClassLoader(plugin) {
        (0, _classCallCheck3.default)(this, PluginClassLoader);

        _Assert2.default.notNull('plugin', plugin);
        this.plugin = plugin;
    }

    /**
     * 加载类型
     * 
     * @param {string} classPath 类所在的类型
     * @returns {*} 返回加载的类
     * @memberof PluginClassLoader
     */


    (0, _createClass3.default)(PluginClassLoader, [{
        key: 'loadClass',
        value: function loadClass(classPath) {
            var classFullPath = _path2.default.join(this.plugin.pluginDirectory, classPath);
            if (!_fs2.default.existsSync(classFullPath)) {
                _log2.default.logger.error('Failed to load class ' + classPath + ' from plugin ' + this.plugin.id);
                return null;
            }
            try {
                return require(classFullPath);
            } catch (error) {
                _log2.default.logger.error('Failed to load class ' + classPath + ' from plugin ' + this.plugin.id, error);
            }
            return null;
        }
    }]);
    return PluginClassLoader;
}();

exports.default = PluginClassLoader;
//# sourceMappingURL=PluginClassLoader.js.map